import * as types from 'modulesV2/constants';

export function setModalId(modalId, options = {}) {
  return {type: types.MODAL_SET, modalId, options};
}

export function clearModal() {
  return {type: types.MODAL_SET};
}

export function setAriaHiddenMainContent(isMainContentAriaHidden) {
  return {
    type: types.SET_ARIA_HIDDEN_MAIN_CONTENT,
    isMainContentAriaHidden
  };
}
/**
 * Launches a snackbar/toast (bottom) message to inform the user on what happened
 * in response to an interaction on the website.
 * Statuses: info, success, danger, warning, etc.
 * @param {object} data - A message to be displayed to the user in the UI.
 * @param {string | element} data.text - The text to display in the message.
 * @param {string} data.status - The status color to display the message in.
 * @param {string} data.objectType - The database object type that triggered the message.
 * @param {element} data.action - The action to display. It renders after the message, at the end of the snackbar.
 * @param {string} data.actionName - The event action name.
 * @param {element} data.action - The action to display. It renders after the message, at the end of the snackbar.
 * @param {string} data.duration - An enumerable string for duration (regular, long, never). Default: regular
 * @param {object} data.eventProperties - Additional properties to sent in the event stream.
 * @param {object} data.meta - Additional information that may be needed for the message.
 */
export function createMessage(data) {
  return {type: types.CREATE_MESSAGE, data};
}

/**
 * Delete all messages from the snackbar/toast.
 */
export function deleteMessage() {
  return {type: types.DELETE_MESSAGE};
}

/**
 * Set context for user interactions. This value represents
 * the textset that a user is currently exploring, or has navigated from.
 */
export function setContext(data) {
  return {type: types.SET_CONTEXT, data};
}
